import { newE2EPage } from "@stencil/core/testing";

describe("rendering", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-line-chart></uic-line-chart>`);
        const el = await page.find("uic-line-chart");
        expect(el).toHaveClass("hydrated");
    });

    it("should display the no data indicator without data property", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-line-chart></uic-line-chart>`);
        const el = (await page.find("uic-line-chart")) as any;

        expect(el).toMatchSnapshot();
    });

    it("should display the loading indicator overlay when state is set to loading", async () => {
        const page = await newE2EPage();

        await page.setContent(
            `<uic-line-chart state="LOADING"></uic-line-chart>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        expect(el).toMatchSnapshot();
    });

    it("should display the no data indicator with empty data property value", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-line-chart></uic-line-chart>`);
        const el = (await page.find("uic-line-chart")) as any;

        el.data = {};

        expect(el).toMatchSnapshot();
    });

    it("should display the no data indicator with an invalid data property value", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-line-chart></uic-line-chart>`);
        const el = (await page.find("uic-line-chart")) as any;

        el.data = [100, 1000];

        expect(el).toMatchSnapshot();
    });

    it("should display the chart with a valid data property value only", async () => {
        const page = await newE2EPage();

        await page.setContent(
            `<div style="height: 400px"><uic-line-chart></uic-line-chart></div>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        // disable transitions so we don't have to wait for DOM stability
        el.setProperty("transitionDurationMs", 0);
        el.setProperty("xScaleType", "band");
        el.setProperty("data", {
            x1: { subgroup1: 1000 },
            x2: { subgroup1: 500 },
        });

        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });

    it("should display the chart with a valid data property value for time scale", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<div style="height: 400px"><uic-line-chart locale="it-IT"></uic-line-chart></div>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        // disable transitions so we don't have to wait for DOM stability
        el.setProperty("transitionDurationMs", 0);
        el.setProperty("data", {
            "2020-05-28T00:00:00Z": { subgroup1: 1000 },
            "2020-05-29T00:00:00Z": { subgroup1: 500 },
        });

        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });

    it("should display the chart with a valid data property value and config", async () => {
        const page = await newE2EPage();

        await page.setContent(
            `<div style="height: 400px"><uic-line-chart></uic-line-chart></div>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        // disable transitions so we don't have to wait for DOM stability
        el.setProperty("transitionDurationMs", 0);
        el.setProperty("xScaleType", "band");
        el.setProperty("data", {
            x1: { subgroup1: 1000 },
            x2: { subgroup1: 500 },
        });
        el.setProperty("groupConfig", {
            subgroup1: { label: "Sub Group 1", cssClass: "subgroup1" },
        });

        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });

    it("should display the chart and y axis label with a valid data property value and y-axis-label", async () => {
        const page = await newE2EPage();

        await page.setContent(
            `<div style="height: 400px"><uic-line-chart y-axis-label="test label"></uic-line-chart></div>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        // disable transitions so we don't have to wait for DOM stability
        el.setProperty("transitionDurationMs", 0);
        el.setProperty("xScaleType", "band");
        el.setProperty("data", {
            x1: { subgroup1: 1000 },
            x2: { subgroup1: 500 },
        });
        el.setProperty("groupConfig", {
            subgroup1: { label: "Sub Group 1", cssClass: "subgroup1" },
        });

        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });

    it("should rotate x axis tick label if they would overlap", async () => {
        const page = await newE2EPage();

        await page.setContent(
            `<div style="height: 400px; width: 400px"><uic-line-chart y-axis-label="test label"></uic-line-chart></div>`
        );
        const el = (await page.find("uic-line-chart")) as any;

        // disable transitions so we don't have to wait for DOM stability
        el.setProperty("transitionDurationMs", 0);
        el.setProperty("xScaleType", "band");
        el.setProperty("data", {
            "some random long label": { subgroup1: 1000 },
            "another log label": { subgroup1: 500 },
        });
        el.setProperty("groupConfig", {
            subgroup1: { label: "Sub Group 1", cssClass: "subgroup1" },
        });

        await page.waitForChanges();

        expect(el).toMatchSnapshot();
    });
});
